const Flickity = require('flickity');
export function homeShopCarousel() {
  const carouselContainer = document.querySelectorAll('.js-home-shop-carousel-container');
  if(carouselContainer) {
    for (let i = 0; i < carouselContainer.length; i++) {
      const _carouselContainer = carouselContainer[i];
      const carousel = _carouselContainer.querySelector('.js-home-shop-carousel');
      const prev = _carouselContainer.querySelector('.js-carousel-prev');
      const next = _carouselContainer.querySelector('.js-carousel-next');
      if(carousel) {
        const flkty = new Flickity(carousel, {
          cellSelector: '.js-home-shop-carousel-cell',
          cellAlign: 'left',
          wrapAround: true,
          groupCells: true,
          setGallerySize: false,
          prevNextButtons: false,
          pageDots: false,
          pauseAutoPlayOnHover: false
        });
        if(prev){
          prev.addEventListener('click', (e) => {
            flkty.previous();
            e.preventDefault();
          });
        }
        if(next){
          next.addEventListener('click', (e) => {
            flkty.next();
            e.preventDefault();
          });
        }
      }
    }
  }
}